import { IFloorPlanModel, IProject } from '@api/models';
import { useOutletContext } from 'react-router-dom';

type ContextData = {
    floorPlan: IFloorPlanModel;
    project: IProject;
    isFloorPlanQueryLoading: boolean;
};

const useFloorPlanLayoutContext = () => {
    const context = useOutletContext<ContextData>();

    if (context == null) {
        throw new Error('Component must have <FloorPlanLayout /> as parent.');
    }

    return context;
};

export default useFloorPlanLayoutContext;
